import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useHistory, useLocation } from "react-router";
import swal from "sweetalert";
import {
    GetAllCompanyData,
    deleteOthersDetailsIr,
    getInvestmentSummary,
    getLinkedCompanies,
    deleteInvestmentTransaction,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as FilterIcon } from "../../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusIconBlack } from "../../../myfin_v2/assets/icons/plusBlack.svg";
import { ReactComponent as DownloadIcon } from "../../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as DownArrow } from "../../../myfin_v2/assets/icons/down-arrow.svg";
import EmptyBox from "../../../myfin_v2/assets/icons/empty-box.png";

const IRDetails = () => {
    const history = useHistory();
    //const [IrData, setIrData] = useState([]);
    const [IrSummary, setIrSummary] = useState([]);
    const [anchorEl3, setAnchorEl3] = useState(null);
    const [IrOneData, setIRData] = useState("");
    const location = useLocation();
    const b = location.pathname.split("/");
    const registerID = b[2];

    const [allCompany, setAllCompany] = useState([]);

    // ── Replaced static groups with API-driven company list ───────────────────
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [openDropdown, setOpenDropdown] = useState(false);

  useEffect(() => {
    fetchInvestmentSummary();
    companyData();
    fetchLinkedCompanies();
}, []);

    const open = Boolean(anchorEl3);
    const id = open ? "simple-popover" : undefined;

    // ── Fetch linked companies for dropdown ───────────────────────────────────
    const fetchLinkedCompanies = async () => {
        try {
            const res = await getLinkedCompanies(registerID);
            // API: { success: true, companies: [{ _id, company_name, company_code }] }
            const list = res.data?.companies || [];
            setCompanies(list);
            if (list.length > 0) {
                setSelectedCompany(list[0]); // auto-select first company
            }
        } catch (error) {
            console.error("Failed to fetch linked companies:", error);
        }
    };

    const companyData = async () => {
        try {
            const res = await GetAllCompanyData();
            if (res.status === 200) {
                setAllCompany(res.data.getAllCompanyData);
            }
        } catch (error) {
            console.log(error.message, "error");
        }
    };

   const fetchInvestmentSummary = async () => {
    try {
        const res = await getInvestmentSummary(registerID);

        if (res.data.success) {
            setIrSummary(res.data.summary || []);
        }
    } catch (error) {
        console.error("Summary fetch failed:", error);
    }
};

    const CompanyName = (c_id) => {
        try {
            const nameCompany = allCompany.filter((adj) => adj._id === c_id);
            return nameCompany[0]?.company_name || "";
        } catch (error) {
            return "";
        }
    };

    const handleClick = (event, data) => {
        setAnchorEl3(event.currentTarget);
        setIRData(data);
    };

    const handleClose = () => {
        setAnchorEl3(null);
    };

    const handleEditIr = (data) => {
        history.push(`/edit-investment/${registerID}/${data._id}`);
    };

   const handleDeleteIr = async (data) => {
    swal({
        title: "Are you sure?",
        text: "This transaction will be permanently deleted!",
        buttons: true,
        dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                try {
                    await deleteInvestmentTransaction(
                        registerID,           
                        data.latestTransaction?._id  
                    );

                    fetchInvestmentSummary();
                    setAnchorEl3(null);

                    swal("Deleted Successfully!", {
                        icon: "success",
                    });

                } catch (err) {
                    swal("Error!", err?.response?.data?.message || "Something went wrong.", "error");
                }
            }
        });
    };

    return (
        <div className={commoncss.pageLayout}>
            <Sidebar />
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu activeTab={"Investments"} registerID={b[2]} />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRContainer}>
                        <div className={investmentRegisterCss.topBar}>

                            {/* ── Linked Companies Dropdown ── */}
                            <div className={investmentRegisterCss.dropdownWrapper}>
                                <div
                                    className={investmentRegisterCss.dropdownField}
                                    onClick={() => setOpenDropdown(!openDropdown)}
                                >
                                    <span>{selectedCompany ? selectedCompany.company_name : "Select Company"}</span>
                                    <motion.span
                                        animate={{ rotate: openDropdown ? 180 : 0 }}
                                        transition={{ duration: 0.2 }}
                                        className={investmentRegisterCss.chevron}
                                    >
                                        <DownArrow />
                                    </motion.span>
                                </div>
                                {openDropdown && (
                                    <div className={investmentRegisterCss.dropdownMenu}>
                                        {companies.map((company) => (
                                            <div
                                                key={company._id}
                                                className={investmentRegisterCss.dropdownItem}
                                                onClick={() => {
                                                    setSelectedCompany(company);
                                                    setOpenDropdown(false);
                                                }}
                                            >
                                                {company.company_name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className={investmentRegisterCss.iRHeader}>
                                <FilterIcon />
                                <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<DownloadIcon height={16} />}
                                    label="Export"
                                />
                                <Button
                                    btnColor={buttoncss.primary}
                                    icon={<PlusIcon />}
                                    label="Create Investment"
                                    onClick={() => history.push(`/create-investment/${registerID}`)}
                                />
                            </div>
                        </div>

                        <div className={investmentRegisterCss.iRDataContainer}>
                            <table className={investmentRegisterCss.irTable} style={{ width: "100%", height: "100%" }}>
                                <thead>
                                    <tr>
                                        <th style={{ borderTopLeftRadius: "20px", textAlign: "left", paddingLeft: "20px" }}>Investees</th>
                                        <th>Investment value</th>
                                        <th>Number of shares</th>
                                        <th>Percentage holding</th>
                                        <th>Nature of relationship</th>
                                        <th style={{ borderTopRightRadius: "20px" }}></th>
                                    </tr>
                                </thead>
                                <tbody style={{ height: "100%" }}>
                                    {IrSummary.length === 0 ? (
                                        <tr style={{ height: "100%" }}>
                                            <td colSpan={6} style={{ height: "78vh", textAlign: "center", verticalAlign: "middle" }}>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px" }}>
                                                    <img src={EmptyBox} alt="No investments" style={{ width: "250px", height: "100px" }} />
                                                    <p style={{ fontWeight: "600", fontSize: "20px", color: "#183930", margin: 0 }}>No Investments are added</p>
                                                    <p style={{ fontSize: "16px", color: "#4D6D64", margin: 0 }}>Create a new investment</p>
                                                    <button
                                                        onClick={() => history.push(`/create-investment/${registerID}`)}
                                                        style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "8px", padding: "8px 20px", border: "1px solid #7ECEA7", borderRadius: "8px", background: "#fff", cursor: "pointer", fontSize: "16px", color: "#1A4338", fontWeight: "500", lineHeight: "1" }}
                                                    >
                                                        <PlusIconBlack style={{ width: "14px", height: "14px" }} />
                                                        Create Investment
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                       IrSummary.map((row, index) => {
                                        const latest = row.latestTransaction || {};

                                        return (
                                            <tr key={index}>
                                                <td
                                                    style={{ textAlign: "left", paddingLeft: "20px", cursor: "pointer" }}
                                                    onClick={() =>
                                                        history.push(`/investmentregister/${registerID}/${row.investmentPairKey}`)
                                                    }
                                                    >
                                                    {row.investeeCompanyData?.company_name || "-"}
                                                    </td>

                                                <td>{latest?.totalConsideration || "-"}</td>
                                                <td>{latest?.noOfSharesPurchased || "-"}</td>
                                                <td>
                                                {latest?.noOfSharesPurchased && latest?.totalSharesOutstanding
                                                    ? ((latest.noOfSharesPurchased / latest.totalSharesOutstanding) * 100).toFixed(1) + "%"
                                                    : "-"}
                                                </td>
                                                <td>{latest?.natureOfRelationship || "-"}</td>

                                                <td>
                                                    <MenuDotsIcon
                                                        onClick={(e) => handleClick(e, row)}
                                                        style={{ cursor: "pointer", marginRight: 20 }}
                                                    />

                                                    <Popover
                                                        id={id}
                                                        open={open}
                                                        anchorEl={anchorEl3}
                                                        onClose={handleClose}
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                    >
                                                        <div className={investmentRegisterCss.irOptions}>
                                                            <span
                                                                style={{ borderBottom: "1px solid #EAEEED" }}
                                                                onClick={() => {
                                                                    handleEditIr(IrOneData);
                                                                    handleClose();
                                                                }}
                                                            >
                                                                Edit Investment
                                                            </span>

                                                            <span
                                                                onClick={() => {
                                                                    handleDeleteIr(IrOneData);
                                                                    handleClose();
                                                                }}
                                                            >
                                                                Delete Investment
                                                            </span>
                                                        </div>
                                                    </Popover>
                                                </td>
                                            </tr>
                                        );
                                    })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default IRDetails;